import script from "./PCConfiguracionComunProcesosTA.vue?vue&type=script&setup=true&lang=js"
export * from "./PCConfiguracionComunProcesosTA.vue?vue&type=script&setup=true&lang=js"

import "./PCConfiguracionComunProcesosTA.vue?vue&type=style&index=0&id=8d46a21e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d46a21e"]])

export default __exports__